import { h } from 'preact';
import { Textarea } from '../Textarea';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Textarea',
  category: '📝 Formulários',
  description: 'Campo de texto multilinha com label e placeholder',
  usedIn: ['AgentesPage', 'Profile'],
  example: () => (
    <Textarea label="Descrição" value="" onChange={() => {}} placeholder="Digite aqui..." rows={3} />
  ),
};
